"use client";

import { IconCopy } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import CopyToClipboard from "react-copy-to-clipboard";
import { DiscountGradient } from "@/components/common/gradients/discount-gradient";
import { DiscountGradientIcon } from "@/components/common/gradients/discount-gradient-icon";
import { toast } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";

type NoResultsOfferCouponProps = {
  className?: string;
  code: string;
  description?: string | null;
};

export const NoResultsOfferCoupon = ({
  className,
  code,
  description,
}: NoResultsOfferCouponProps) => {
  const t = useTranslations("diets");

  return (
    <DiscountGradient className={cn("w-full rounded-lg p-px", className)}>
      <CopyToClipboard
        onCopy={() =>
          toast.success(
            <span>
              <span>{t("discountCodeCopied")}</span>
              <span className="font-bold">{code}</span>
            </span>,
          )
        }
        text={code}
      >
        <button
          className="flex w-full items-center gap-4 rounded-lg bg-white p-4 text-left text-primary"
          type="button"
        >
          <DiscountGradientIcon className="h-14 w-14 text-xl">
            %
          </DiscountGradientIcon>
          <span className="block min-w-0">
            <span className="block font-medium text-xl">
              {t("no_results_offer.code_label")} {code}
            </span>
            {description && (
              <span className="block font-normal text-sm">{description}</span>
            )}
          </span>
          <span className="ml-auto hidden h-12 shrink-0 items-center gap-2 rounded-md border border-brand-green2-300 px-4 font-medium text-base md:inline-flex">
            {t("no_results_badge.cta")}
            <IconCopy className="h-5 w-5" />
          </span>
        </button>
      </CopyToClipboard>
    </DiscountGradient>
  );
};
